import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import uniqueId from 'react-html-id';
import RoundButton from '../../_atomic/RoundButton/RoundButton';
import './MediaLibrary.scss';
import MediaLibraryPlaceholder from '../../_atomic/MediaLibraryPlaceholder/MediaLibraryPlaceholder';

const preloader = require('./assets/preloader.svg');
const deleteIcon = require('./assets/delete.png');
const videoPlaceholder = require('./assets/video-placeholder.png');


class MediaLibrary extends Component {
    static propTypes = {
      value: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
      deleteHandler: PropTypes.func,
    }

    static defaultProps = {
      deleteHandler: () => null,
    }

    constructor() {
      super();
      uniqueId.enableUniqueIds(this);
    }

    state = {
      mediaPreviews: {},
    }

    componentDidUpdate(prevProps) {
      const value = [...this.props.value];
      const mediaPreviews = { ...this.state.mediaPreviews };
      if (prevProps.value.length !== value.length) {
        value.forEach((file) => {
          const fileId = `${file.name}${file.size}${file.lastModified}`;
          if (!mediaPreviews[fileId]) {
            mediaPreviews[fileId] = {};
            mediaPreviews[fileId].file = file;
            if (file.type.indexOf('image') > -1) {
              this.readFileUrl(file, fileId);
            } else {
              mediaPreviews[fileId].preview = videoPlaceholder;
            }
          }
        });
        this.setState(() => ({
          mediaPreviews,
        }));
      }
    }

    readFileUrl = (file, fileId) => {
      if (file) {
        if (file.type.indexOf('image') > -1) {
          const reader = new FileReader();
          reader.onload = () => {
            const mediaPreviews = { ...this.state.mediaPreviews };
            mediaPreviews[fileId].preview = reader.result;
            this.setState(() => ({
              mediaPreviews,
            }));
          };
          reader.readAsDataURL(file);
        }
      }
    }

    deleteHandler = ({ file: { name, size, lastModified } }) => {
      const mediaPreviews = { ...this.state.mediaPreviews };
      delete mediaPreviews[`${name}${size}${lastModified}`];

      this.setState(() => ({
        mediaPreviews,
      }), () => {
        this.props.deleteHandler({ name, size, lastModified });
      });
    }


    renderMediaItem = (item) => {
      const mediaItemWrapperClasses = classNames({
        'media-item-wrapper': true,
        loading: !item.preview,
      });

      return (
        <div key={this.nextUniqueId()} className={mediaItemWrapperClasses}>
          <div className="image-preloader">
            <img src={preloader} alt="preloader" />
          </div>
          <RoundButton onClick={() => { this.deleteHandler(item); }} radius="20px"> <img src={deleteIcon} alt="X" /> </RoundButton>
          <div className="media-item" > <div style={{ backgroundImage: `url(${item.preview})` }}className="media-item-image" /> <div className="media-item-name"><span>{item.file.name}</span></div> </div>
        </div>
      );
    }

    render() {
      const { mediaPreviews } = this.state;

      return (
        <div className="media-library">
          <MediaLibraryPlaceholder itemsLength={Object.keys(mediaPreviews).length} />

          { Object.keys(mediaPreviews)
          .map(mediaId => this.renderMediaItem(mediaPreviews[mediaId], mediaId))}
        </div>
      );
    }
}

export default MediaLibrary;



// WEBPACK FOOTER //
// ./src/components/_molecules/MediaLibrary/MediaLibrary.js